export default "__VITE_ASSET__Dw9l$ZIt__"